module.exports = __webpack_public_path__ + "static/media/explore.7267a0fe.svg";